"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTwisterPlus = void 0;
const react_1 = __importStar(require("react"));
const router_1 = require("next/router");
const monera_app_core_1 = require("@amzn/monera-app-core");
const __1 = require("..");
const styles_1 = require("../../canvas-box/styles");
const carousel_1 = require("../../carousel");
const divider_1 = require("../../divider");
const page_wrapper_1 = require("../../page-wrapper");
const themed_text_1 = require("../../themed-text");
const styles_2 = require("../../themed-text/styles");
const styles_3 = require("./styles");
const view_1 = require("./view");
const ProductTwisterPlus = ({ seeAvailableOptionsCopy, rowIndexToDisplayVariationDetails, variationMap = {}, dimensionKeys = [], dimensionValues = [], showPaginationButtons = false, headingString = '', compareVariationsString = '', compareVariationsHref = '#compare', isLoading = false, compareClickHandler, showMobileTopDivider = true }) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const deviceType = (0, react_1.useContext)(page_wrapper_1.PageContext).deviceType;
    const [variationState] = (0, react_1.useState)((0, __1.getVariationValuesFromAsin)(variationMap, configStoreState.asin) || []);
    const [buttonContainerOpenState, setIsButtonContainerOpen] = (0, react_1.useState)(() => {
        return new Array(dimensionKeys.length).fill(true);
    });
    const router = (0, router_1.useRouter)();
    const [buttonTextHeight, setButtonTextHeight] = (0, react_1.useState)();
    const buttonTextRefs = (0, react_1.useRef)([]);
    (0, react_1.useEffect)(() => {
        var _a;
        (_a = buttonTextRefs.current) === null || _a === void 0 ? void 0 : _a.map((buttonTextRef) => {
            (buttonTextRef === null || buttonTextRef === void 0 ? void 0 : buttonTextRef.clientHeight) > 20 && setButtonTextHeight(buttonTextRef.clientHeight);
        });
    }, []);
    const handleOnClick = (dimensionKeyIndex, dimensionValueIndex) => __awaiter(void 0, void 0, void 0, function* () {
        const newState = [...variationState];
        newState[dimensionKeyIndex] = dimensionValueIndex;
        const asin = (0, __1.getAsinFromVariation)(variationMap, newState) ||
            (0, __1.getAsinFromClick)(variationMap, dimensionKeyIndex, dimensionValueIndex);
        const currentPath = router.asPath;
        const newPath = currentPath.substring(0, currentPath.indexOf('/dp/')) + '/dp/';
        const query = Object.assign({}, router.query);
        const twisterPrefix = `twister_`;
        const ref = query.ref ? query.ref : null;
        if (!ref || ref.startsWith(twisterPrefix)) {
            query.ref = twisterPrefix + configStoreState.asin;
        }
        delete query.asin;
        asin &&
            router.replace({
                pathname: '/dp/[asin]',
                query: Object.assign(Object.assign({}, query), { asin })
            }, {
                pathname: newPath + asin,
                query
            }, {
                scroll: false
            });
    });
    const handleButtonLabelClick = (index) => {
        setIsButtonContainerOpen((prev) => {
            const newState = [...prev];
            newState[index] = !prev[index];
            return newState;
        });
    };
    const isMobile = deviceType === monera_app_core_1.DeviceType.Mobile || deviceType === monera_app_core_1.DeviceType.MShop;
    const renderMobileTopDivider = isMobile && showMobileTopDivider;
    return dimensionKeys.length !== 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
        renderMobileTopDivider && react_1.default.createElement(styles_3.MobileTopDivider, { margin: '0rem -1.2rem' }),
        react_1.default.createElement(styles_1.StyledContainer, { "margin-top": '4px' },
            headingString && (react_1.default.createElement(styles_1.StyledItem, { "data-cy": "twister-heading", width: "100%", textAlign: "center", margin: "20px 0px 8px 0px" },
                react_1.default.createElement(styles_2.ThemedH1, null, headingString))),
            dimensionKeys.map(({ displayString }, dimensionKeyIndex) => {
                const shallDisplayTwister = dimensionValues[dimensionKeyIndex].length > 1;
                const shallDisplayVariationDetails = dimensionKeyIndex === rowIndexToDisplayVariationDetails;
                return (react_1.default.createElement(react_1.default.Fragment, { key: dimensionKeyIndex },
                    dimensionKeyIndex > 0 && react_1.default.createElement(styles_3.StyledDivider, { margin: '', deviceType: deviceType }),
                    react_1.default.createElement(styles_3.TwisterPlusLabelContainer, { "data-cy": "twister-plus-label-container", isOpen: buttonContainerOpenState[dimensionKeyIndex], onClick: () => handleButtonLabelClick(dimensionKeyIndex) },
                        react_1.default.createElement(styles_3.TwisterPlusLabelText, { "data-cy": "twister-plus-label-text" },
                            react_1.default.createElement(themed_text_1.ThemedSpan, null,
                                displayString,
                                ": "),
                            react_1.default.createElement(themed_text_1.ThemedSpan, { bold: true }, dimensionValues[dimensionKeyIndex][variationState[dimensionKeyIndex]])),
                        shallDisplayTwister && react_1.default.createElement("i", { className: "a-icon a-icon-dropdown" })),
                    buttonContainerOpenState[dimensionKeyIndex] && shallDisplayTwister && (react_1.default.createElement(styles_3.TwisterPlusButtonContainer, { "data-cy": "twister-plus-button-container" },
                        react_1.default.createElement(carousel_1.Carousel, { "data-cy": "twister-plus-carousel", delayRightArrowRender: true, useAutoSlideWidth: false, circularPaging: false, imageMargins: "12px", showPaginationButtons: showPaginationButtons, hidePaginationButtonsAtEnds: true, slidesPerPage: 2, initialFocusSlideIndex: variationState[dimensionKeyIndex], showPaginationDots: false, paginateWholePage: true, leftPaginationButtonDistance: "4px", rightPaginationButtonDistance: "4px", renderRightPaginationButton: (onClick) => (react_1.default.createElement(styles_3.StyledCarouselButton, { "aria-label": "Right", "data-cy": "twister-plus-carousel-right-button", role: "button", onClick: onClick },
                                react_1.default.createElement("i", { className: "a-icon a-icon-next" }))), renderLeftPaginationButton: (onClick) => (react_1.default.createElement(styles_3.StyledCarouselButton, { "aria-label": "Left", "data-cy": "twister-plus-carousel-left-button", role: "button", onClick: onClick },
                                react_1.default.createElement("i", { className: "a-icon a-icon-previous" }))), elements: dimensionValues[dimensionKeyIndex].map((e, dimensionValueIndex) => {
                                const variationValues = [...variationState];
                                variationValues[dimensionKeyIndex] = dimensionValueIndex;
                                const asin = (0, __1.getAsinFromVariation)(variationMap, variationValues);
                                return (react_1.default.createElement(styles_3.TwisterPlusButton, { "data-cy": "twister-plus-button", deviceType: deviceType, first: dimensionValueIndex === 0, selected: variationState[dimensionKeyIndex] === dimensionValueIndex, isValid: !!asin, shallDisplayVariationDetails: shallDisplayVariationDetails, key: e, onClick: () => {
                                        handleOnClick(dimensionKeyIndex, dimensionValueIndex);
                                    } },
                                    react_1.default.createElement(styles_1.StyledItem, { margin: "0px", padding: "9px", width: "100%" },
                                        react_1.default.createElement(styles_3.TwisterPlusButtonText, { bold: true, "data-cy": "twister-plus-button-text", ref: (el) => shallDisplayVariationDetails && buttonTextRefs.current.push(el), isValid: !!asin, shallDisplayVariationDetails: shallDisplayVariationDetails, height: buttonTextHeight }, e)),
                                    shallDisplayVariationDetails && (react_1.default.createElement(view_1.VariationDetails, { isLoading: isLoading, variationMap: variationMap, variationValues: variationValues, seeAvailableOptionsCopy: seeAvailableOptionsCopy, "data-cy": "twister-variation-details" }))));
                            }) }))),
                    shallDisplayVariationDetails && compareVariationsString && (react_1.default.createElement(styles_1.StyledItem, { margin: "0px 0px 12px 0px" }, compareClickHandler ? (react_1.default.createElement(themed_text_1.ThemedAnchor, { href: "#", onClick: (event) => {
                            compareClickHandler(event);
                            return false;
                        } }, compareVariationsString)) : (react_1.default.createElement(themed_text_1.ThemedAnchor, { href: compareVariationsHref }, compareVariationsString)))),
                    react_1.default.createElement(divider_1.Divider, { margin: '0px 0px 8px 0px', height: '0px' })));
            })))) : null;
};
exports.ProductTwisterPlus = ProductTwisterPlus;
